import React, { useEffect, useRef, useState } from "react";
import { GatsbyImage } from "gatsby-plugin-image";
import Hotspot from "../UI/Hotspot/Hotspot";
import * as classes from "./ImageWithHotspot.module.scss";
import Container from "../UI/Container/Container";
import styled from "styled-components";

const ImageBorder = styled.div`
  /* z-index: ; */
  position: relative;
  padding: 0;
  z-index: 0;
  @media (min-width: 641px) {
    padding: 15px;
  }
`;

const RevealImageSection = styled.section`
  position: absolute;
  inset: 0;
  transition: opacity 0.6s;
  opacity: ${(props) => props.op};
  @media (min-width: 641px) {
    inset: 15px;
  }
`;
const OriginalImageSection = styled.section`
  inset: 0;
  transition: opacity 0.6s;
  opacity: ${(props) => props.op};
  @media (min-width: 641px) {
    inset: 15px;
  }
`;

const ImageWithHotspot = (props) => {
  const [currentImage, setcurrentImage] = useState(props.imageName);
  const [overlayOpacity, setOverlayOpacity] = useState(0);
  const onMouseEnterHandler = () => {
    setOverlayOpacity((d) => Math.abs(d - 1));
  };
  const onMouseLeaveHandler = () => {
    setOverlayOpacity((d) => Math.abs(d - 1));
  };

  const revealImageRef = useRef();
  const initialImageRef = useRef();
  return (
    <Container>
      <div style={{ backgroundColor: "white" }}>
        <div className={classes.HotspotImage__HeaderGroup}>
          <h2>{props.heading}</h2>
          <h3>{props.subheading}</h3>
        </div>

        <ImageBorder>
          <RevealImageSection ref={revealImageRef} op={overlayOpacity}>
            <GatsbyImage
              loading="eager"
              image={props.images[props.hoverImageName].gatsbyImageData}
              alt="TEST"
            />
          </RevealImageSection>
          <OriginalImageSection
            ref={initialImageRef}
            style={{ opacity: Math.abs(overlayOpacity - 1) }}
          >
            <GatsbyImage
              loading="eager"
              image={props.images[props.imageName].gatsbyImageData}
              alt="TEST"
            />
          </OriginalImageSection>
          {props.hotspots.map((d, i) => {
            return (
              <Hotspot
                onMouseEnter={onMouseEnterHandler}
                onMouseLeave={onMouseLeaveHandler}
                onHotspotClick={() => {
                  return props.onHotspotClick(d);
                }}
                hotspotData={d}
                key={`d.imageName${i}`}
              ></Hotspot>
            );
          })}
        </ImageBorder>
      </div>
    </Container>
  );
};
export default ImageWithHotspot;
